var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.36 277.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#0067ab;}.c{fill:#fff;}.d{fill:#00afe8;}.e{fill:#0091e2;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "238.36 69.11 193.05 95.38 193.02 95.38 119.22 52.59 45.38 95.42 0 69.11 119.18 0 238.36 69.11"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "119.18 226.39 119.18 277.66 0 208.52 0 69.11 45.38 95.42 45.38 183.59 119.18 226.39"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "119.22 138.17 119.22 140.76 119.18 140.8 119.18 138.21 119.22 138.17"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "238.36 69.11 238.36 208.52 119.18 277.66 119.18 226.39 119.22 226.42 193.05 183.59 193.05 95.42 193.02 95.38 193.05 95.38 238.36 69.11"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "193.05 183.59 119.22 226.42 119.18 226.39 45.38 183.59 119.18 140.8 119.22 140.76 193.05 183.59"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "193.05 95.42 193.05 183.59 119.22 140.76 119.22 52.59 193.02 95.38 193.05 95.42"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "119.22 52.59 119.22 138.17 119.18 138.21 119.18 140.8 45.38 183.59 45.38 95.42 119.22 52.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.dd4059438816b34f9b34c9f2d372a194.svg";
export { ForwardRef as ReactComponent };